export const ERROR_MESSAGES = {
  BAD_REQUEST: "Please check your input and try again",
  AUTHENTICATION_FAILED: "Invalid credentials. Please try again",
  PERMISSION_ERROR: "You don't have permission to perform this action",
  RESOURCE_NOT_FOUND: "The requested resource could not be found",
  VALIDATION_ERROR: "Please fill in all required fields correctly",
}

export const getErrorMessage = (error) => {
  const errorCode = error?.response?.data?.error?.code
  const validationDetails = error?.response?.data?.error?.details

  // Handle validation errors with details
  if (errorCode === "VALIDATION_ERROR" && validationDetails?.length > 0) {
    const fieldErrors = validationDetails.map((detail) => {
      const field = detail.loc[detail.loc.length - 1]
      return `${field}: ${detail.msg}`
    })
    return fieldErrors.join(", ")
  }

  // Return mapped message or default message
  return ERROR_MESSAGES[errorCode] || "Something went wrong!"
}
